import { validateShopPermissions } from 'modules/shop/shared/parsers';
import { mergePermissionsParser, validateRoles } from 'shared/parsers';
import {UseAccessParams} from "shared/types/UseAccessParams";

type UseExtendedAccessParams = UseAccessParams & {auth: any}

export const checkAccess = ({ environment, permission, licence, role, shopPermissions: shopRoles, auth }: UseExtendedAccessParams) => {

  const { permissions, licences, roles, shopPermissions } = auth.data ?? {};

  const mergedPermissions = permissions ? mergePermissionsParser(permissions) : [];

  let checkEnvironment = true;
  if (environment) {
    checkEnvironment = Array.isArray(environment)
      ? environment.includes(process.env.REACT_APP_ENV as string)
      : environment === process.env.REACT_APP_ENV;
  }
  const checkPermission = permission ? mergedPermissions.includes(permission) : true;
  const checkLicence = licence ? licences.includes(licence) : true;
  const checkRole = role ? validateRoles(roles, role) : true;
  const checkShopPermissions =
    shopRoles && shopRoles.length ? validateShopPermissions(shopPermissions, shopRoles) : true

  return checkEnvironment && checkPermission && checkLicence && checkRole && checkShopPermissions;
};
